import { memo, useCallback, useMemo } from 'react';
import { useFormat } from 'helpers/hooks/useFormat';
import { useProductList } from '../../context';
import { Sort } from '../../context/types';

type Props = {
  onClick?: () => void;
};

type ItemProps = {
  active?: boolean;
  children?: React.ReactNode;
  onClick: (sort: Sort) => void;
  sort: Sort;
};
const SortFacetItem: React.FC<ItemProps> = memo(function SortFacetItem({ active, children, onClick, sort }) {
  const handleClick = useCallback(() => onClick(sort), [onClick, sort]);
  return (
    <div
      className={`cursor-pointer p-[14px] transition hover:bg-neutral-200 ${active ? 'bg-neutral-200' : 'bg-transparent'}`}
      onClick={handleClick}
    >
      {children}
    </div>
  );
});

const SortFacet: React.FC<Props> = ({ onClick }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const { replaceSort, activeSort } = useProductList();

  const options = useMemo<Array<{ label: string; attribute: string; value: 'asc' | 'desc' }>>(() => {
    return [
      {
        label: formatMessage({ id: 'sort.priceAsc', defaultMessage: 'Prezzo crescente' }),
        attribute: 'best_price',
        value: 'asc',
      },
      {
        label: formatMessage({ id: 'sort.priceDesc', defaultMessage: 'Prezzo decrescente' }),
        attribute: 'best_price',
        value: 'desc',
      },
      {
        label: formatMessage({ id: 'sort.newest', defaultMessage: 'Più recenti' }),
        attribute: 'firstSeasonDate',
        value: 'desc',
      },
    ];
  }, [formatMessage]);

  const updateSort = useCallback(
    (newSort: Sort) => {
      replaceSort(newSort);
      onClick && onClick();
    },
    [onClick, replaceSort],
  );

  return (
    <div>
      {options.map((x) => (
        <SortFacetItem
          key={`${x.attribute}-${x.value}`}
          active={x.attribute === activeSort?.attribute && x.value === activeSort?.value}
          sort={x}
          onClick={updateSort}
        >
          {x.label}
        </SortFacetItem>
      ))}
    </div>
  );
};

export default SortFacet;
